import type { ComponentType, FC, ReactNode } from 'react';

import styles from './Vazio.module.scss';

// O ESTADO VAZIO do Carbon: pictograma, título, uma frase e, quando houver, a ação que tira a
// tela do vazio. É para "ainda não há nada aqui"; busca ou filtro sem resultado é uma linha de
// texto na própria lista (a lista existe, o que falta é o resultado).

export const Vazio: FC<{
  pictograma: ComponentType<{ className?: string; 'aria-hidden'?: boolean }>;
  titulo: string;
  texto?: string;
  acao?: ReactNode;
  /** O que o vazio explica além da frase (uma lista, um segundo parágrafo), antes da ação. */
  children?: ReactNode;
}> = ({ pictograma: Pictograma, titulo, texto, acao, children }) => (
  <div className={styles.vazio}>
    <Pictograma className={styles.pictograma} aria-hidden />
    <h2 className={styles.titulo}>{titulo}</h2>
    {texto && <p className={styles.texto}>{texto}</p>}
    {children}
    {acao && <div className={styles.acao}>{acao}</div>}
  </div>
);
